import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppContext } from '../../context/AppContext';
import {Label, Input, Select}  from '../../Shared'
import axios from 'axios';

const CalcForm = ({ 
  onClose, 
  editItemId, 
setReset,
reset,
product,
setProduct,
setEditItemId,
setCalcOpen

}) => {
const {axiUrl,user} = useAppContext()
const [defaultProducts, setDefaultProducts] =useState([])
        
const PAPER = [
    {
     name:'',
     weight:'',
     divide:'',   
    },
]
const [formData, setFormData] = useState(product ? { name: product.name,
        weightType: product.weightType || 'Self Mailer',
        weight: product.weight,
        weightUnit: product.weightUnit || 'OZ',
        thickness: product.thickness,
        width: product.width,
        length: product.length,
        paperType: product.paperType || '',
        company: user.company?._id || null,
        user: user._id} :{ 
    weightType: 'Self Mailer',
        weight: '',
        weightUnit: 'OZ',
        thickness: '',
        length: '',
        paperType: '',
        company: user.company?._id || null,
        user: user._id,

});

useEffect(() => {
const getdefaults = async() => {
await axios.get(`${axiUrl}/products/getdefaultproducts`)
.then(res => {
    console.log(res.data)
setDefaultProducts(res.data.data)
})
}
getdefaults()

},[])


  const handleDefaultSelect = (e) => {
    const parts = e.target.value.split(' -');
 ;
    const selectedName =  parts[0];
    const product = defaultProducts.find((p) => p.name === selectedName);
    if (product) {
      setFormData({
        name: "",
        weightType: product.type || 'Self Mailer',
        weight: product.weight,
        weightUnit: product.weightUnit || 'OZ',
        thickness: product.thickness,
        width: product.width,
        length: product.length,
        paperType: product.paperType || '',
        company: user.company?._id || null,
        user: user._id,
      });
    } else {
      setFormData({
         name: "",
         weightType: 'Self Mailer',
        weight: '',
        weightUnit: 'OZ',
        thickness: '',
        length: '',
        paperType: '',
        company: user.company?._id || null,
        user: user._id
      }); 
    }
  };
console.log(formData)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


 const handleSubmit = async (e) => {
    e.preventDefault();
    const url = editItemId ? `${axiUrl}/products/update` : `${axiUrl}/products/add`;
    const payload = editItemId ? { ...formData, id: editItemId } : formData;
    try {
          console.log(editItemId)
        console.log(payload)
      const res = await axios.post(url, payload);
       
      await setProduct(null)
      
     toast.success(res.data.message || `Product ${editItemId ? 'updated' : 'added'} successfully`);
    await setReset(!reset);
   
   onClose()
    } catch (err) {
      console.error('Error submitting product:', err);
    
      toast.error('Error submitting product');
    }
  };

  



  return (
    <div
      className="overflow-hidden transition-all duration-500 ease-in-out max-h-[1000px] opacity-100 translate-y-0 bg-white rounded-lg shadow-md p-6 mb-6 border-1"
    >
    
        <>
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
           Calculator
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* <div>
              <Label className="block text-sm font-medium text-gray-700">Select Default Product</Label>
              <Select
                onChange={handleDefaultSelect}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              >
                <option value="">Custom Product</option>
                {defaultProducts?.map((product) => (
                  <option key={product._id} value={product.name}>
                    {product.name} - {product.paperType}&nbsp;{product.weightType}
                  </option>
                ))}
              </Select>
             
            </div> */}
            <div>
              <Label className="block text-sm font-medium text-gray-700">Name</Label>
              <Input
                type="text"
                name="name"
                value={formData?.name}
                onChange={handleChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                required
              />
            </div>
            
            {/* Width and Length on one line */}
            <div className='flex gap-[10px]'>
              <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Flat Width (in)</Label>
                <Input
                  type="number"
                  step="0.01"
                  name="width"
                  value={formData?.width}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  required
                />
              </div>
              <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Flat Length (in)</Label>
                <Input
                  type="number"
                  step="0.01"
                  name="length"
                  value={formData?.length}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  required
                />
              </div>
            </div>

<div className='flex gap-[10px]'>
              <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Folded Width (in)</Label>
                <Input
                  type="number"
                  step="0.01"
                  name="width"
                  value={formData?.width}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  required
                />
              </div>
              <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Folded Length (in)</Label>
                <Input
                  type="number"
                  step="0.01"
                  name="length"
                  value={formData?.length}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                  required
                />
              </div>
            </div>

            {/* Weight and Thickness on another line */}
       <div className='flex gap-[10px]'>
                 <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Paper</Label>
                  <Select
                                    name="weightUnit"
                                    value={formData?.weightUnit}
                                    onChange={handleChange}
                                    className="w-24 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                                  >
                                    <option value="oz">oz</option>
                                    <option value="lbs">lbs</option>
                                  </Select>
              </div>
              <div className='flex-1'>
                <Label className="block text-sm font-medium text-gray-700">Type</Label>
                  <Select
                                    name="weightUnit"
                                    value={formData?.weightUnit}
                                    onChange={handleChange}
                                    className="w-24 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                                  >
                                    <option value="oz">oz</option>
                                    <option value="lbs">lbs</option>
                                  </Select>
              </div>
            </div>
          
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                onClick={() => {
                 onClose()
                }}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
              >
                {editItemId ? 'Update Item' : 'Add Item'}
              </button>
            </div>
          </form>
        </>

    </div>
  );
};

export default CalcForm;

